import { render, staticRenderFns } from "./UiRadio.vue?vue&type=template&id=1ccb736f&scoped=true"
import script from "./UiRadio.vue?vue&type=script&lang=js"
export * from "./UiRadio.vue?vue&type=script&lang=js"
import style0 from "./UiRadio.vue?vue&type=style&index=0&id=1ccb736f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb736f",
  null
  
)

export default component.exports